(() => {
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => [...c.querySelectorAll(s)];
  const safe = (s) => String(s ?? '').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
  const money = (cents) => new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR'}).format((Number(cents)||0)/100);
  const pushDL = (payload) => { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); };

  async function cartJSON(){ const r=await fetch('/cart.js',{headers:{Accept:'application/json'}}); if(!r.ok) throw new Error('Cart failed'); return r.json(); }
  const updateCount = cart => $$('.cart-link [data-cart-count], [data-cart-count]').forEach(el => el.textContent=cart.item_count);

  function cartProductTitle(title){ return String(title||'').replace(' Premium Instant Coffee','').replace(' 50 gms','').replace(' 50 Gms',''); }

  function renderCartDrawer(cart){
    const body=$('[data-cart-body]'); if(!body) return;
    if(!cart.items.length){ body.innerHTML=`<div class="empty-cart"><span class="empty-cart-mark">✦</span><h3>YOUR CART IS EMPTY.</h3><p>Your next favourite coffee is waiting.</p><a class="btn btn-light" href="${document.body.dataset.shopUrl||'/collections/all'}">SHOP MEUCO ↗</a></div>`; const rec=$('[data-cart-reco]'); if(rec) rec.hidden=true; return; }
    body.innerHTML = cart.items.map(i => `<article class="cart-line" data-cart-line="${safe(i.key)}"><a href="${safe(i.url||'#')}"><img src="${safe(i.image||'')}" alt="${safe(i.product_title)}"></a><div class="cart-line-main"><a href="${safe(i.url||'#')}"><strong>${safe(cartProductTitle(i.product_title))}</strong></a><span>${safe(money(i.final_price))}</span><div class="drawer-line-controls"><div class="drawer-qty"><button type="button" data-drawer-qty="-1" data-line-key="${safe(i.key)}" aria-label="Decrease quantity">−</button><span>${i.quantity}</span><button type="button" data-drawer-qty="1" data-line-key="${safe(i.key)}" aria-label="Increase quantity">+</button></div><button type="button" class="drawer-remove" data-drawer-remove="${safe(i.key)}">REMOVE</button></div></div><strong class="drawer-line-total">${safe(money(i.final_line_price))}</strong></article>`).join('');
    const threshold=Number($('[data-cart-drawer]')?.dataset.freeShippingThreshold||50000), progress=Math.min(100,Math.round((cart.total_price/threshold)*100));
    const pt=$('[data-cart-progress-text]'), pv=$('[data-cart-progress-value]'), pb=$('[data-cart-progress-bar]');
    if(pt) pt.textContent=cart.total_price>=threshold?'FREE SHIPPING UNLOCKED*':`ADD ${money(threshold-cart.total_price)} TO UNLOCK FREE SHIPPING*`;
    if(pv) pv.textContent=money(cart.total_price); if(pb) pb.style.width=`${progress}%`;
    renderCartRecommendations(cart);
  }

  async function renderCartRecommendations(cart){
    const box=$('[data-cart-reco]'), grid=$('[data-cart-reco-grid]'); if(!box||!grid||!cart.items.length)return;
    const exclude=new Set(cart.items.map(i=>i.product_id));
    try{
      const r=await fetch('/recommendations/products.json?product_id='+cart.items[0].product_id+'&limit=4');
      if(!r.ok)return; const j=await r.json(); const products=(j.products||[]).filter(p=>!exclude.has(p.id)).slice(0,2);
      grid.innerHTML=products.map(p=>`<article class="cart-reco-item"><a href="${p.url}"><img src="${p.featured_image||''}" alt="${safe(p.title)}"><strong>${safe(cartProductTitle(p.title))}</strong></a><button type="button" data-quick-add data-variant-id="${p.variants?.[0]?.id||''}">ADD +</button></article>`).join(''); box.hidden=products.length===0;
    }catch{ box.hidden=true; }
  }

  async function refreshCart(){ try{ const cart=await cartJSON(); updateCount(cart); renderCartDrawer(cart); return cart; }catch(e){console.error(e); return null;} }
  function openCart(){ const d=$('[data-cart-drawer]'); if(!d)return; closeSearch(); d.setAttribute('aria-hidden','false'); document.body.classList.add('drawer-open'); refreshCart(); }
  function closeCart(){ const d=$('[data-cart-drawer]'); if(!d)return; d.setAttribute('aria-hidden','true'); document.body.classList.remove('drawer-open'); }


async function addToCart(variantId, qty = 1, source = 'quick_add', goCheckout = false) {
  const quantityRequested = Math.max(1, Number(qty) || 1);
  const currency = window.Shopify?.currency?.active || 'INR';

  // Add the selected Shopify variant to cart.
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: Number(variantId),
        quantity: quantityRequested
      }]
    })
  });

  if (!response.ok) {
    let errorData = {};
    try {
      errorData = await response.json();
    } catch (_) {}

    throw new Error(
      errorData.description || 'Could not add product to cart'
    );
  }

  const added = await response.json();
  const lines = Array.isArray(added.items) ? added.items : [added];

  // Read the actual price from Shopify's successful cart response.
  const items = lines.map(line => {
    const variant = String(line.variant_id ?? line.id ?? variantId);
    const quantity = Math.max(
      1,
      Number(line.quantity ?? quantityRequested) || 1
    );

    const unitCents = Number(line.final_price ?? line.price ?? 0);

    const totalCents = Number(
      line.final_line_price ??
      line.line_price ??
      (unitCents * quantity)
    );

    return {
      id: variant,
      productId: String(line.product_id ?? variant),
      name: line.product_title || line.title || '',
      quantity,
      price: Number((unitCents / 100).toFixed(2)),
      lineValue: Number((totalCents / 100).toFixed(2))
    };
  });

  const addedValue = Number(
    items.reduce((sum, item) => sum + item.lineValue, 0).toFixed(2)
  );

  // Keep a complete numeric ecommerce payload in dataLayer.
  pushDL({ ecommerce: null });

  pushDL({
    event: 'add_to_cart',
    ecommerce: {
      currency,
      value: addedValue,
      items: items.map(item => ({
        item_id: item.productId,
        item_variant: item.id,
        item_name: item.name,
        price: item.price,
        quantity: item.quantity
      }))
    },
    source
  });

  // Direct Meta event for Product Page actions only.
  // Shop Page's existing Event Setup mapping remains untouched.
  const isProductPage =
    source === 'product_page' ||
    source === 'buy_now';

  if (isProductPage && typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart', {
      content_ids: items.map(item => item.id),
      content_type: 'product',
      content_name: items.map(item => item.name).join(', '),
      value: addedValue,
      currency,
      contents: items.map(item => ({
        id: item.id,
        quantity: item.quantity,
        item_price: item.price
      })),
      num_items: items.reduce((sum, item) => sum + item.quantity, 0)
    });
  }

  // Buy Now means checkout initiation, NOT a completed purchase.
  if (goCheckout) {
    let checkoutValue = addedValue;
    let checkoutItems = items;

    try {
      const cartResponse = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });

      if (cartResponse.ok) {
        const cart = await cartResponse.json();

        checkoutValue = Number((cart.total_price / 100).toFixed(2));

        checkoutItems = cart.items.map(item => ({
          id: String(item.variant_id),
          quantity: Number(item.quantity) || 1,
          price: Number((item.final_price / 100).toFixed(2))
        }));
      }
    } catch (error) {
      console.warn('Could not refresh checkout value:', error);
    }

    if (isProductPage && typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout', {
        content_ids: checkoutItems.map(item => item.id),
        content_type: 'product',
        value: checkoutValue,
        currency,
        contents: checkoutItems.map(item => ({
          id: item.id,
          quantity: item.quantity,
          item_price: item.price
        })),
        num_items: checkoutItems.reduce(
          (sum, item) => sum + item.quantity,
          0
        )
      });
    }

    pushDL({ ecommerce: null });

    pushDL({
      event: 'begin_checkout',
      ecommerce: {
        currency,
        value: checkoutValue,
        items: checkoutItems.map(item => ({
          item_id: item.id,
          price: item.price,
          quantity: item.quantity
        }))
      }
    });

    window.location.href = '/checkout';
    return;
  }

  openCart();
}

  document.addEventListener('keydown', e=>{const card=e.target.closest('[data-card-quick-add]');if(card&&(e.key==='Enter'||e.key===' ')){e.preventDefault();card.click()}});

  async function updateLine(key, quantity){
    const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
    if(!r.ok)throw new Error('Cart update failed'); const cart=await r.json(); updateCount(cart); renderCartDrawer(cart); pushDL({event:'cart_update',item_count:cart.item_count});
  }

  // Global click interactions
  document.addEventListener('click', async e => {
    const add=e.target.closest('[data-quick-add], [data-card-quick-add]');
    if(add){ e.preventDefault(); e.stopPropagation(); if(add.dataset.busy||!add.dataset.variantId)return; add.dataset.busy='1'; const old=add.innerHTML; if(add.matches('button')){add.disabled=true;add.innerHTML='ADDING…';} try{await addToCart(add.dataset.variantId,1,add.hasAttribute('data-card-quick-add')?'card_click':'quick_add')}catch(err){if(add.matches('button')){add.innerHTML='TRY AGAIN';setTimeout(()=>add.innerHTML=old,1600)}} finally{if(add.matches('button')){add.disabled=false;if(add.innerHTML==='ADDING…')add.innerHTML=old} delete add.dataset.busy;} return; }
    if(e.target.closest('[data-cart-toggle]')){e.preventDefault();openCart();return;}
    if(e.target.closest('[data-cart-close]')){e.preventDefault();closeCart();return;}
    if(e.target.closest('[data-menu-open]')){e.preventDefault();closeCart();closeSearch();$('[data-mobile-drawer]')?.setAttribute('aria-hidden','false');document.body.classList.add('drawer-open','mobile-menu-open');return;}
    if(e.target.closest('[data-menu-close]')){e.preventDefault();$('[data-mobile-drawer]')?.setAttribute('aria-hidden','true');document.body.classList.remove('drawer-open','mobile-menu-open');return;}
    if(e.target.closest('[data-search-open]')){e.preventDefault();openSearch();return;}
    if(e.target.closest('[data-search-close]')){e.preventDefault();closeSearch();return;}
    const copy=e.target.closest('[data-copy-code]'); if(copy){ try{await navigator.clipboard?.writeText(copy.dataset.copyCode); const t=copy.textContent; copy.textContent='COPIED ✓'; setTimeout(()=>copy.textContent=t,1500)}catch{} return; }
    const qty=e.target.closest('[data-drawer-qty]'); if(qty){e.preventDefault();const cart=await cartJSON();const item=cart.items.find(i=>i.key===qty.dataset.lineKey);if(item)await updateLine(item.key,Math.max(0,item.quantity+Number(qty.dataset.drawerQty)));return;}
    const rem=e.target.closest('[data-drawer-remove]'); if(rem){e.preventDefault();await updateLine(rem.dataset.drawerRemove,0);return;}
    const sug=e.target.closest('[data-search-suggestion]'); if(sug){const input=$('[data-search-input]');if(input){input.value=sug.dataset.searchSuggestion;input.dispatchEvent(new Event('input',{bubbles:true}));input.focus()}return;}
    const recover=e.target.closest('[data-recover-toggle]'); if(recover){e.preventDefault();document.querySelector(recover.getAttribute('href'))?.classList.toggle('is-open');return;}
    const pageQty=e.target.closest('[data-page-qty]'); if(pageQty){e.preventDefault(); const form=pageQty.closest('[data-cart-page-form]'); const input=$(`[data-page-qty-input="${pageQty.dataset.lineKey}"]`); if(input){input.value=Math.max(0,(Number(input.value)||1)+Number(pageQty.dataset.pageQty||0)); updateCartPageLine(pageQty.dataset.lineKey,input.value,form)} return;}
    const pageRemove=e.target.closest('[data-page-remove]'); if(pageRemove){e.preventDefault();updateCartPageLine(pageRemove.dataset.pageRemove,0,pageRemove.closest('[data-cart-page-form]'));return;}
  });

  async function updateCartPageLine(key,qty,form){
    const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:Number(qty)||0})}); if(!r.ok) return;
    window.location.reload();
  }

  // Product cards: card surface navigates, controls remain independent.
  document.addEventListener('click',e=>{const card=e.target.closest('[data-product-card]');if(!card||e.target.closest('a,button,input,select,textarea,label'))return;const u=card.getAttribute('data-product-url');if(u)window.location.href=u});

  // Search
  let searchTimer=null;
  function openSearch(){const d=$('[data-search-drawer]');if(!d)return;closeCart();d.setAttribute('aria-hidden','false');document.body.classList.add('drawer-open');setTimeout(()=> $('[data-search-input]')?.focus(),180)}
  function closeSearch(){const d=$('[data-search-drawer]');if(!d)return;d.setAttribute('aria-hidden','true');if(!document.querySelector('[data-cart-drawer][aria-hidden="false"]'))document.body.classList.remove('drawer-open')}
  const sinput=$('[data-search-input]'); if(sinput) sinput.addEventListener('input',()=>{clearTimeout(searchTimer);const q=sinput.value.trim(),out=$('[data-predictive-results]');if(!out)return;if(q.length<2){out.innerHTML='';return}searchTimer=setTimeout(async()=>{try{const r=await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`,{headers:{Accept:'application/json'}});const j=await r.json();const ps=j.resources?.results?.products||[];out.innerHTML=ps.map(p=>`<a class="predictive-card" href="${p.url}"><img src="${p.image||''}" alt="${safe(p.title)}"><div><span>MEUCO</span><strong>${safe(cartProductTitle(p.title))}</strong><b>${safe(p.price)}</b></div></a>`).join('')||'<div class="search-no-results">NO MATCHES YET. TRY ANOTHER MOOD.</div>';}catch{out.innerHTML='<div class="search-no-results">SEARCH IS TAKING A COFFEE BREAK. TRY AGAIN.</div>'}},180)});

  // Hero stack: robust mouse/touch swipe + native links for cards.
  const hero=$('[data-hero-stack]'); if(hero){
    const items=$$('[data-stack-item]',hero), count=items.length, controls=hero.parentElement, counter=$('[data-hero-stack-count]',controls);
    let active=0,timer=null,downX=0,delta=0,pointerId=null,drag=false,suppressClickUntil=0;
    const render=()=>{items.forEach((el,i)=>{const rel=(i-active+count)%count;el.dataset.stackState=rel===0?'active':rel===1?'next':rel===count-1?'prev':rel===2?'next2':'back';});if(counter)counter.textContent=`${String(active+1).padStart(2,'0')} / ${String(count).padStart(2,'0')}`};
    const stop=()=>{if(timer)clearInterval(timer);timer=null};
    const start=()=>{if(count<2||matchMedia('(prefers-reduced-motion: reduce)').matches)return;stop();timer=setInterval(()=>{active=(active+1)%count;render()},Number(hero.dataset.interval)||4500)};
    const go=d=>{active=(active+d+count)%count;render();start()};
    hero.addEventListener('dragstart',e=>e.preventDefault());
    hero.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse'&&e.button!==0)return;
      if(e.target.closest('.hero-stage-cta-wrap,.hero-stack-controls'))return;
      pointerId=e.pointerId; downX=e.clientX; delta=0; drag=false; stop(); hero.classList.add('is-dragging');
    });
    hero.addEventListener('pointermove',e=>{
      if(pointerId!==e.pointerId)return;
      delta=e.clientX-downX;
      if(Math.abs(delta)>7)drag=true;
      if(drag){e.preventDefault();hero.style.setProperty('--swipe-x',`${Math.max(-160,Math.min(160,delta))}px`);}
    },{passive:false});
    const finish=e=>{
      if(pointerId!==e.pointerId)return;
      if(drag && Math.abs(delta)>55){active=(active+(delta<0?1:-1)+count)%count;suppressClickUntil=Date.now()+450;}
      pointerId=null; hero.classList.remove('is-dragging'); hero.style.setProperty('--swipe-x','0px'); render(); start();
    };
    hero.addEventListener('pointerup',finish); hero.addEventListener('pointercancel',finish); hero.addEventListener('pointerleave',e=>{if(pointerId===e.pointerId&&e.pointerType==='mouse'&&drag){} });
    hero.addEventListener('click',e=>{if(Date.now()<suppressClickUntil){e.preventDefault();e.stopPropagation();}},true);
    $('[data-hero-prev]',controls)?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();go(-1)});
    $('[data-hero-next]',controls)?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();go(1)});
    // Direct click routing makes every visible hero card reliably navigable.
    items.forEach(item=>item.addEventListener('click',e=>{
      if(Date.now()<suppressClickUntil||drag){e.preventDefault();e.stopPropagation();return;}
      const href=item.getAttribute('href');
      if(href && e.target.closest('.hero-product-tile')){e.preventDefault();window.location.assign(href);}
    }));
    render(); start();
  }

  // Generic drag carousel helper for flavours and videos.
  // Uses native scrollLeft so mouse drag, touch swipe, arrows and autoplay
  // all share one coordinate system (no transform/blank-space bugs).
  function initRail(root, viewportSel, trackSel, cardSel, prevSel, nextSel, visibleFn, interval=4200){
    if(!root)return;
    const vp=$(viewportSel,root), track=$(trackSel,root), cards=$$(cardSel,root), prev=$(prevSel,root), next=$(nextSel,root);
    if(!vp||!track||!cards.length)return;

    let timer=null, pointerId=null, startX=0, startScroll=0, dragging=false, suppressClickUntil=0;
    let activeIndex=0;

    const gap=()=>parseFloat(getComputedStyle(track).gap)||0;
    const step=()=>{const w=cards[0]?.getBoundingClientRect().width||0;return w+gap()};
    const visible=()=>Math.max(1,Number(visibleFn?.()||1));
    const maxIndex=()=>Math.max(0,cards.length-visible());
    const clamp=i=>Math.max(0,Math.min(maxIndex(),Number(i)||0));
    const maxScroll=()=>Math.max(0,vp.scrollWidth-vp.clientWidth);

    const sync=()=>{
      const s=step();
      if(!s)return;
      activeIndex=clamp(Math.round(vp.scrollLeft/s));
      const progress=$('[data-flavour-progress]',root);
      if(progress){
        const total=Math.max(1,maxIndex());
        progress.style.width=`${Math.max(8,Math.round((activeIndex/total)*100))}%`;
      }
    };

    const scrollToIndex=(i,behavior='smooth')=>{
      activeIndex=clamp(i);
      vp.scrollTo({left:Math.min(maxScroll(),activeIndex*step()),behavior});
      sync();
    };

    const stop=()=>{if(timer){clearInterval(timer);timer=null}};
    const startAuto=()=>{
      stop();
      if(cards.length<=visible()||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      timer=setInterval(()=>scrollToIndex(activeIndex>=maxIndex()?0:activeIndex+1,'smooth'),interval);
    };
    const go=d=>{scrollToIndex(activeIndex+d,'smooth');startAuto()};

    vp.addEventListener('scroll',sync,{passive:true});
    vp.addEventListener('dragstart',e=>e.preventDefault());

    vp.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse'&&e.button!==0)return;
      if(e.target.closest('button,a'))return;
      pointerId=e.pointerId;
      startX=e.clientX;
      startScroll=vp.scrollLeft;
      dragging=false;
      stop();
      vp.classList.add('is-dragging');
      try{vp.setPointerCapture(e.pointerId)}catch{}
    });

    vp.addEventListener('pointermove',e=>{
      if(pointerId!==e.pointerId)return;
      const dx=e.clientX-startX;
      if(Math.abs(dx)>6)dragging=true;
      if(dragging){
        e.preventDefault();
        vp.scrollLeft=Math.max(0,Math.min(maxScroll(),startScroll-dx));
      }
    },{passive:false});

    const finish=e=>{
      if(pointerId!==e.pointerId)return;
      const dx=e.clientX-startX;
      if(dragging){
        if(Math.abs(dx)>Math.max(18,step()*.14)) activeIndex=clamp(activeIndex+(dx<0?1:-1));
        suppressClickUntil=Date.now()+450;
        scrollToIndex(activeIndex,'smooth');
      }else{
        sync();
      }
      pointerId=null;
      dragging=false;
      vp.classList.remove('is-dragging');
      try{vp.releasePointerCapture?.(e.pointerId)}catch{}
      startAuto();
    };

    vp.addEventListener('pointerup',finish);
    vp.addEventListener('pointercancel',finish);
    vp.addEventListener('wheel',e=>{
      if(Math.abs(e.deltaX)+Math.abs(e.deltaY)<2)return;
      e.preventDefault();
      go((e.deltaX||e.deltaY)>0?1:-1);
    },{passive:false});
    vp.addEventListener('click',e=>{
      if(Date.now()<suppressClickUntil){e.preventDefault();e.stopPropagation();}
    },true);
    prev?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();go(-1)});
    next?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();go(1)});

    window.addEventListener('resize',()=>{activeIndex=clamp(activeIndex);scrollToIndex(activeIndex,'auto')},{passive:true});
    scrollToIndex(0,'auto');
    startAuto();
  }
  initRail($('[data-flavour-carousel]'),'[data-flavour-viewport]','[data-flavour-track]','[data-flavour-card]','[data-flavour-prev]','[data-flavour-next]',()=>innerWidth<=640?2:innerWidth<=900?3:4,3800);
  initRail($('[data-video-carousel]'),'[data-video-viewport]','[data-video-track]','.video-card','[data-video-prev]','[data-video-next]',()=>innerWidth<=640?2:innerWidth<=900?2:3,4200);
  $$('#MainContent video').forEach(v=>{v.muted=true;v.playsInline=true;const obs='IntersectionObserver' in window?new IntersectionObserver(es=>es.forEach(x=>{if(x.isIntersecting)v.play().catch(()=>{});else v.pause()}),{threshold:.5}):null;obs?.observe(v);if(!obs)v.play().catch(()=>{});});

  // Find Your MEUCO quiz — 3 questions, backed by the first 9 products in the selected collection.
  const quiz=$('[data-quiz]');
  if(quiz){
    let cfg={questions:[],results:[]};
    try{cfg=JSON.parse($('[data-meuco-quiz-config]',quiz)?.textContent||'{}')}catch{}
    let step=0,ans=[];
    const intro=$('.quiz-intro',quiz),stage=$('[data-quiz-stage]',quiz),q=$('[data-quiz-question]',quiz),opts=$('[data-quiz-options]',quiz),prog=$('[data-quiz-progress]',quiz),bar=$('[data-quiz-progress-bar]',quiz),back=$('[data-quiz-back]',quiz);
    const render=()=>{
      const item=cfg.questions?.[step]; if(!item)return;
      prog.textContent=`${step+1} / ${cfg.questions.length}`; bar.style.width=`${((step+1)/cfg.questions.length)*100}%`;
      q.textContent=item.question;
      opts.innerHTML=(item.options||[]).map((label,i)=>`<button type="button" class="quiz-option" data-i="${i}">${safe(label)}<span>→</span></button>`).join('');
      back.hidden=step===0;
    };
    const finish=()=>{
      const a0=Number(ans[0]?.index||0),a1=Number(ans[1]?.index||0),a2=Number(ans[2]?.index||0);
      const resultIndex=(a0*3+a1+a2)%Math.max(1,cfg.results.length); const r=cfg.results[resultIndex]||cfg.results[0];
      q.textContent='YOUR MEUCO IS';bar.style.width='100%';
      if(!r){opts.innerHTML=`<div class="quiz-result"><p class="eyebrow">MEET YOUR MATCH</p><h3>MEUCO IS YOUR MOOD.</h3><a class="btn btn-light btn-glow" href="${document.body.dataset.shopUrl||'/collections/all'}">SHOP ALL FLAVOURS ↗</a></div>`;return;}
      opts.innerHTML=`<div class="quiz-result">${r.image?`<img src="${safe(r.image)}" alt="${safe(r.result)}">`:''}<p class="eyebrow">MEET YOUR MATCH</p><h3>${safe(r.result)}</h3><a class="btn btn-light btn-glow" href="${safe(r.url)}">SHOP ${safe(r.result)} ↗</a><button type="button" class="text-link" data-quiz-restart>RETAKE QUIZ</button></div>`;
      back.hidden=true;pushDL({event:'quiz_complete',quiz_name:'find_your_meuco',recommendation:r.result,recommendation_index:resultIndex});
    };
    $('[data-quiz-start]',quiz)?.addEventListener('click',()=>{intro.hidden=true;stage.hidden=false;step=0;ans=[];render();pushDL({event:'quiz_start',quiz_name:'find_your_meuco'});});
    opts.addEventListener('click',e=>{
      const b=e.target.closest('[data-i]');
      if(b){const index=Number(b.dataset.i);ans[step]={index,label:cfg.questions?.[step]?.options?.[index]||''};step++;if(step<cfg.questions.length)render();else finish();return;}
      if(e.target.closest('[data-quiz-restart]')){step=0;ans=[];intro.hidden=false;stage.hidden=true;}
    });
    back?.addEventListener('click',()=>{if(step>0){step--;ans.pop();render()}});
  }

  document.addEventListener('click',e=>{const c=e.target.closest('[data-floating-video-close]');if(c){c.closest('[data-floating-product-video]')?.remove();}});

// Product gallery: one large 3:4 image with thumbnail navigation; mobile thumbnails move below the main image.
  const pdpGallery=$('[data-product-page] .pdp-gallery-v5');
  if(pdpGallery){
    const stageItems=$$('[data-pdp-stage-item]',pdpGallery);
    const thumbs=$$('[data-pdp-thumb]',pdpGallery);
    const showMedia=(idx)=>{
      stageItems.forEach((el,i)=>{el.classList.toggle('is-active',i===idx);el.setAttribute('aria-hidden',i===idx?'false':'true');});
      thumbs.forEach((el,i)=>{el.classList.toggle('is-active',i===idx);el.setAttribute('aria-selected',i===idx?'true':'false');});
      stageItems.forEach((el,i)=>$$('video',el).forEach(v=>{if(i===idx)v.play?.().catch(()=>{});else v.pause?.();}));
    };
    thumbs.forEach((btn,i)=>btn.addEventListener('click',()=>showMedia(i)));
  }

  // Product form + Buy Now + mobile sticky purchase bar.
  const pf=$('[data-product-form]');
  if(pf){
    const getVariant=()=>Number($('[data-variant-select]',pf)?.value||$('[data-variant-input]',pf)?.value||0);
    const qty=()=>Math.max(1,Number($('input[name="quantity"]',pf)?.value)||1);
    $('[data-qty-minus]',pf)?.addEventListener('click',()=>{const i=$('input[name="quantity"]',pf);if(i)i.value=Math.max(1,Number(i.value||1)-1)});
    $('[data-qty-plus]',pf)?.addEventListener('click',()=>{const i=$('input[name="quantity"]',pf);if(i)i.value=Math.max(1,Number(i.value||1)+1)});
    const doBuyNow=async(button)=>{const old=button.textContent;button.disabled=true;button.textContent='ADDING…';try{await addToCart(getVariant(),qty(),'buy_now',true)}catch{button.disabled=false;button.textContent=old}};
    $('[data-buy-now]',pf)?.addEventListener('click',e=>doBuyNow(e.currentTarget));
    $('[data-mobile-buy-now]')?.addEventListener('click',e=>doBuyNow(e.currentTarget));
    pf.addEventListener('submit',async e=>{e.preventDefault();const b=$('.pdp-buy-button--primary',pf);if(!b)return;b.disabled=true;const old=b.textContent;b.textContent='ADDING…';try{await addToCart(getVariant(),qty(),'product_page')}catch{b.textContent='TRY AGAIN';setTimeout(()=>b.textContent=old,1500)}finally{b.disabled=false;if(b.textContent==='ADDING…')b.textContent=old}});
    $('[data-variant-select]',pf)?.addEventListener('change',e=>{$('[data-buy-now]',pf)?.setAttribute('data-variant-id',e.target.value);});
  }

  // Collection filters: auto-apply via section rendering + history, no hard reload.
  async function applyShopParams(url){const main=$('[data-shop-page]');if(!main)return;const sidebar=$('[data-filter-sidebar]',main);const keepSidebarOpen=sidebar?.getAttribute('aria-hidden')==='false';main.classList.add('is-updating');try{const target=new URL(url,location.origin);target.searchParams.set('section_id','main-collection-custom');const r=await fetch(target.toString(),{headers:{'X-Requested-With':'XMLHttpRequest'}});if(!r.ok)throw new Error('Filter failed');const html=await r.text();const doc=new DOMParser().parseFromString(html,'text/html');const next=doc.querySelector('[data-shop-page]');if(!next)throw new Error('Shop section missing');main.replaceWith(next);history.pushState({},'',url);initShopEvents();const fresh=$('[data-shop-page]');if(keepSidebarOpen&&fresh&&innerWidth<=900){$('[data-filter-sidebar]',fresh)?.setAttribute('aria-hidden','true');document.body.classList.remove('drawer-open')}window.scrollTo({top:Math.max(0,$('[data-shop-toolbar]')?.getBoundingClientRect().top+scrollY-70),behavior:'smooth'});}catch(err){console.error(err);main.classList.add('filter-update-failed');}finally{$('[data-shop-page]')?.classList.remove('is-updating')}}
  function initShopEvents(){const page=$('[data-shop-page]');if(!page)return;const sidebar=$('[data-filter-sidebar]',page);const openSidebar=()=>{sidebar?.setAttribute('aria-hidden','false');document.body.classList.add('drawer-open','shop-filter-open')};const closeSidebar=()=>{sidebar?.setAttribute('aria-hidden','true');document.body.classList.remove('drawer-open','shop-filter-open')};page.querySelectorAll('[data-filter-open]').forEach(btn=>btn.addEventListener('click',openSidebar));page.querySelectorAll('[data-filter-close]').forEach(btn=>btn.addEventListener('click',closeSidebar));const form=$('[data-filter-form]',page);let priceTimer=null;const submitFilters=()=>{const params=new URLSearchParams(new FormData(form));params.delete('page');params.set('sort_by',$('[data-shop-sort]',page)?.value||'best-selling');applyShopParams(`${location.pathname}?${params.toString()}`)};form?.addEventListener('change',e=>{if(e.target.matches('input[type=\"checkbox\"]'))submitFilters()});form?.addEventListener('input',e=>{if(!e.target.matches('input[type=\"number\"]'))return;clearTimeout(priceTimer);priceTimer=setTimeout(submitFilters,650)});form?.addEventListener('keydown',e=>{if(e.key==='Enter'&&e.target.matches('input[type=\"number\"]')){e.preventDefault();clearTimeout(priceTimer);submitFilters()}});$('[data-shop-sort]',page)?.addEventListener('change',()=>submitFilters());}
  initShopEvents();
  window.addEventListener('popstate',()=>location.reload());
})();
